/* eslint-disable */
import { useNavigate, useParams } from "react-router";
import { GetIssuesAndCount } from "../../hooks/userWebsiteData";
import { useState } from "react";
import {
  Checkbox,
  Button,
  CircularProgress,
  Container,
  Box,
  Grid,
  styled,
  Card,
  useTheme,
  Typography,
  FormGroup,
  FormControlLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  tableCellClasses,
} from "@mui/material";
import MainLoader from "../MainLoader/MainLoader";
import { createKanban, syncFlag } from "../../gql/mutations/kanban";
import { useMutation } from "@apollo/client";
import { usePopup } from "../../context/commonPop";
import IssuesFlagHeader from "./IssuesFlagHeader";
import InfoIcon from "@mui/icons-material/Info";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "60px",
}));
const TableWrapper = styled(Box)(({ theme }) => ({
  "& .TableHeader": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media screen and (max-width:768px)": {
      flexDirection: "column",
      justifyContent: "center",
    },
    "& h3": {
      fontSize: "24px",
      fontWeight: 600,
      marginBottom: "20px",
      color: theme.palette.text.primary,
    },
    "& .CheckboxWrapper": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      "& .inputLabel .css-1j8wkzf-MuiTypography-root": {
        color: theme.palette.text.primary,
        fontWeight: 700,
      },
    },
  },
}));
const StyledTableRow = styled(TableRow)(() => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "15px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const TableMainWrapper = styled(Box)(({ theme }) => ({
  "& table": {
    marginTop: "0",
    borderRadius: "12px",
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
    "& thead": {
      "& tr th.MuiTableCell-head": {
        backgroundColor: theme.palette.common.hoverBtn,
        fontSize: "14px",
      },
    },
    "& tbody": {
      "& tr td": {
        color: theme.palette.text.primary,
        padding: "0px 5px",
        "& a": {
          color: theme.palette.text.primary,
          fontWeight: 600,
          "& svg": {
            color: "red",
          },
        },
        "& .HelperIconStyle": {
          color: `${theme.palette.primary.main} !important`,
          transition: "0.3s all",
          cursor: "pointer",
          "&:hover": { color: "#ff642d" },
        },
        "& .MoreIconStyle": {
          color: theme.palette.primary.main,
          cursor: "pointer",
        },
      },

      "& > h5": {
        fontSize: "16px",
        fontWeight: 600,
        padding: "12px 14px 12px",
        color: theme.palette.text.primary,
      },
      "& .indexable": {
        color: theme.palette.text.primary,
        fontWeight: 600,
        fontSize: "12px",
        paddingLeft: "14px",
        fontFamily: "Plus Jakarta Sans', sans-serif !important",
        display: "inline-block",
      },
      "& .Indexability": {
        color: theme.palette.common.black,
        fontSize: "15px",
      },
      "& .Indexabilitylink": {
        fontSize: "15px",
        color: theme.palette.primary.main,
      },
    },
  },
}));
const IssuesFlag = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const [loader, setLoader] = useState(false);
  const { issuesData, loading } = GetIssuesAndCount(projectId);
  const [selectedFlags, setSelectedFlags] = useState([]);
  const [CREATE_KANBAN] = useMutation(createKanban);
  const [SYNCFLAG] = useMutation(syncFlag);
  const [disabledSync, setDisabledSync] = useState(false);
  const [loaderSync, setLoaderSync] = useState(false);
  const navigate = useNavigate();
  const { handleOpen } = usePopup();
  const handleAddFlags = flag => {
    if (selectedFlags.includes(flag)) {
      setSelectedFlags(prev => prev.filter(item => item !== flag));
    } else {
      setSelectedFlags(prev => [...prev, flag]);
    }
  };
  const handleNextClick = () => {
    setLoader(true);
    CREATE_KANBAN({
      variables: {
        data: {
          projectId,
          flags: selectedFlags,
        },
      },
      onCompleted: () => {
        setLoader(false);
        const query = new URLSearchParams({
          flags: selectedFlags.join(","),
        });
        navigate(`/issue-details/${projectId}?path=issue&${query.toString()}`);
      },
      onError: err => {
        console.log("err", err);
        setLoader(false);
      },
    });
  };

  const handleSyncData = () => {
    setDisabledSync(false);
    setLoaderSync(true);
    SYNCFLAG({
      variables: {
        data: {
          projectId,
        },
      },
      onCompleted: () => {
        handleOpen(true, "New data has been synced");
        setDisabledSync(true);
        setLoaderSync(false);
      },
      onError: err => {
        console.log("err", err);
        setLoader(false);
      },
    });
  };

  const projectdetailtable = {
    maxHeight: "calc(100vh - 100px)",
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backgroundColor: theme.palette.text.primary + "0d",
    },
    "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
      backgroundColor: theme.palette.primary.main,
    },
    "& .countColor": {
      color: "red",
    },
  };

  return (
    <>
      <SectionWrapper>
        <Container maxWidth="">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} md={12}>
                <Box sx={{ width: "100%" }}>
                  <IssuesFlagHeader
                    handleNextClick={handleNextClick}
                    selectedFlags={selectedFlags}
                    loader={loader}
                    loaderSync={loaderSync}
                    issuesData={issuesData}
                    disabledSync={disabledSync}
                    handleSyncData={handleSyncData}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} md={12}>
                <TableWrapper>
                  {loading ? (
                    <MainLoader message={"Loading..."} />
                  ) : issuesData?.finalResponse?.length === 0 || !issuesData ? (
                    <Box sx={{ height: "400px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Typography component="p" sx={{ fontWeight: "600" }}>
                        No Data Found
                      </Typography>
                    </Box>
                  ) : (
                    <Card sx={{ padding: { xs: "16px 16px 16px 16px", md: "30px 45px 24px 40px" }, border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
                      <Box className="TableHeader">
                        <Typography component="h3">All issues </Typography>
                        <FormGroup className="CheckboxWrapper">
                          <FormControlLabel
                            className="inputLabel"
                            control={<Checkbox />}
                            value="warning"
                            label="Warning"
                            // onChange={handleStatusChange}
                            // checked={selectedStatus.includes("warning")}
                          />
                          <FormControlLabel
                            className="inputLabel"
                            control={<Checkbox />}
                            value="error"
                            label="Error"
                            // checked={selectedStatus.includes("error")}
                            // onChange={handleStatusChange}
                          />
                          <FormControlLabel
                            className="inputLabel"
                            control={<Checkbox />}
                            value="info"
                            label="Info"
                            // checked={selectedStatus.includes("info")}
                            // onChange={handleStatusChange}
                          />
                        </FormGroup>
                      </Box>
                      <TableMainWrapper sx={{ maxHeight: 440, overflow: "auto", height: 400 }}>
                        <TableContainer sx={projectdetailtable}>
                          <Table sx={{ minWidth: 700, marginTop: 5 }} stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell align="left">Issue</StyledTableCell>
                                <StyledTableCell align="center" sx={{ maxWidth: "150px", minWidth: "0", width: "140px" }}>
                                  Issue Count
                                </StyledTableCell>
                                <StyledTableCell align="center" sx={{ maxWidth: "150px", minWidth: "0", width: "140px" }}>
                                  Action
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {issuesData?.finalResponse?.map(item => {
                                const isSelected = selectedFlags.includes(item?.flag);
                                return (
                                  <StyledTableRow key={item.id}>
                                    <StyledTableCell align="left">
                                      <Box component="span" sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        {/* <InfoIcon sx={{ color: "#3288d7", fontSize: "18px" }} /> */}
                                        {/* <ReportProblemIcon sx={{ color: "#f13333", fontSize: "18px" }} /> */}
                                        {/* <ReportIcon sx={{ color: "#face0d", fontSize: "18px" }} /> */}
                                        <Typography component="span" className="Indexability">
                                          {" "}
                                          {item?.flag}
                                        </Typography>
                                      </Box>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{item?.issueCounts}</StyledTableCell>
                                    <StyledTableCell align="center">
                                      <Checkbox checked={isSelected} onChange={() => handleAddFlags(item?.flag)} />
                                    </StyledTableCell>
                                  </StyledTableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </TableMainWrapper>
                    </Card>
                  )}
                </TableWrapper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </SectionWrapper>
    </>
  );
};

export default IssuesFlag;
